import { render } from "./ParamLink.vue?vue&type=template&id=0f9255fc&scoped=true"
import script from "./ParamLink.vue?vue&type=script&lang=js"
export * from "./ParamLink.vue?vue&type=script&lang=js"

import "./ParamLink.vue?vue&type=style&index=0&id=0f9255fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9255fc"]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
